import React from "react";
import { motion } from "framer-motion";
import DisplayOdd from "../components/DisplayOdd";
const MatchOdd = ({
  onChildRuleShow,
  eventDetails,
  matchOdds,
  setBetSlipDetails,
  matchOddBook,
}) => {
  const showRules = () => {
    onChildRuleShow();
  };

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  let isRunner1Winner = "ACTIVE";
  let isRunner2Winner = "ACTIVE";
  let isRunner3Winner = "ACTIVE";

  const showBetSlip = (betType, teamName, sid, rate) => {
    setBetSlipDetails({
      bet_type: betType,
      runnername: teamName,
      sid: sid,
      odds: rate,
      amount: 0,
      market_type: "m"
    });
  };

  let betAccept = true;

  // runner1
  let r1b = 0;
  let r1b2 = 0;
  let r1b3 = 0;
  let r1l = 0;
  let r1l2 = 0;
  let r1l3 = 0;

  let rate1 = 0;
  let rate2 = 0;
  let rate3 = 0;
  let rate4 = 0;
  let rate5 = 0;
  let rate6 = 0;

  // runner2
  let r2b = 0;
  let r2b2 = 0;
  let r2b3 = 0;
  let r2l = 0;
  let r2l2 = 0;
  let r2l3 = 0;

  let rate7 = 0;
  let rate8 = 0;
  let rate9 = 0;
  let rate10 = 0;
  let rate11 = 0;
  let rate12 = 0;

  // runner3
  let r3b = 0;
  let r3b2 = 0;
  let r3b3 = 0;
  let r3l = 0;
  let r3l2 = 0;
  let r3l3 = 0;

  let rate13 = 0;
  let rate14 = 0;
  let rate15 = 0;
  let rate16 = 0;
  let rate17 = 0;
  let rate18 = 0;

  let rnr1s = 0;
  let rnr2s = 0;
  let rnr3s = 0;

  let oddStatus = "OPEN";

  if (matchOddBook !== null && matchOddBook !== undefined) {
    if (matchOddBook.rnr1s !== undefined) {
      rnr1s = parseInt(matchOddBook.rnr1s);
    }

    if (matchOddBook.rnr2s !== undefined) {
      rnr2s = parseInt(matchOddBook.rnr2s);
    }

    if (matchOddBook.rnr3s !== undefined) {
      rnr3s = parseInt(matchOddBook.rnr3s);
    }
  }

  if (matchOdds !== null && matchOdds !== undefined) {
    //debugger;
    // runner1
    r1b = matchOdds.r1b;
    r1b2 = matchOdds.r1b2;
    r1b3 = matchOdds.r1b3;
    r1l = matchOdds.r1l;
    r1l2 = matchOdds.r1l2;
    r1l3 = matchOdds.r1l3;

    rate1 = matchOdds.rate1;
    rate2 = matchOdds.rate2;
    rate3 = matchOdds.rate3;
    rate4 = matchOdds.rate4;
    rate5 = matchOdds.rate5;
    rate6 = matchOdds.rate6;

    //runner2
    r2b = matchOdds.r2b;
    r2b2 = matchOdds.r2b2;
    r2b3 = matchOdds.r2b3;
    r2l = matchOdds.r2l;
    r2l2 = matchOdds.r2l2;
    r2l3 = matchOdds.r2l3;

    rate7 = matchOdds.rate7;
    rate8 = matchOdds.rate8;
    rate9 = matchOdds.rate9;
    rate10 = matchOdds.rate10;
    rate11 = matchOdds.rate11;
    rate12 = matchOdds.rate12;

    // runner3
    r3b = matchOdds.r3b;
    r3b2 = matchOdds.r3b2;
    r3b3 = matchOdds.r3b3;
    r3l = matchOdds.r3l;
    r3l2 = matchOdds.r3l2;
    r3l3 = matchOdds.r3l3;

    rate13 = matchOdds.rate13;
    rate14 = matchOdds.rate14;
    rate15 = matchOdds.rate15;
    rate16 = matchOdds.rate16;
    rate17 = matchOdds.rate17;
    rate18 = matchOdds.rate18;
    oddStatus = matchOdds.status;
  }

  if (eventDetails !== null && eventDetails !== undefined) {
    if (!eventDetails?.is_bet_accept || eventDetails?.evt_status !== "OPEN") {
      betAccept = false;
    }
  }

  return (
    <div className="table-box-body">
      <div className="tb-content">
        <div className="market-titlebar">
          <p className="market-name">
            <span className="market-name-badge">
              <i className="market-name-icon">
                <img
                  src="/assets/images/time-img.png"
                  style={{
                    filter: "invert(100%)",
                    marginTop: "-8px",
                    marginLeft: "-1px"
                  }}
                />
              </i>
              <span>Match Odds </span>{" "}
              <span style={{ textTransform: "initial" }}>
                (MaxBet: <span id="match_odd_limit">5M</span>)
              </span>
            </span>{" "}
            <span
              className="rules-badge"
              style={{ marginLeft: "-4px" }}
              onClick={() => showRules()}
            >
              <i className="fa fa-info-circle"></i>
            </span>
          </p>
          <div className="market-overarround">
            <span></span>
            <strong>Back</strong>
          </div>
          <div className="market-overarround market-overarround-lay">
            <strong>Lay</strong>
          </div>
        </div>
        <div className="market-runners">
          <div
            className="runner-runner"
            style={{
              background:
                eventDetails !== null &&
                eventDetails !== undefined &&
                eventDetails.stat1 === "WINNER"
                  ? "#b7f777"
                  : ""
            }}
          >
            <h3 className="runner-name">
              <div className="runner-info">
                <span className="clippable runner-display-name">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <h4
                            style={{
                              marginBottom: "0px",
                              fontSize: "16px",
                              fontWeight: "600",
                              WhiteSpace: "normal"
                            }}
                            className="clippable-spacer"
                          >
                            {eventDetails.cat_rnr1}
                          </h4>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div
                            style={{
                              float: "left",
                              fontSize: "15px",
                              color: rnr1s >= 0 ? "green" : "red"
                            }}
                          >
                            {rnr1s !== 0 ? (
                              <span>{formatTruncate(Math.round(rnr1s))}</span>
                            ) : (
                              ""
                            )}
                          </div>
                          <div style={{ marginLeft: "10px", display: "none" }}>
                            &nbsp;&nbsp; <span></span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </div>
            </h3>

            <div className="price-row-box-new">
              <a
                onClick={() =>
                  showBetSlip(
                    "b",
                    eventDetails.cat_rnr1,
                    eventDetails.cat_sid1,
                    r1b3
                  )
                }
                className="price-price price-back"
                data-team="New Zealand"
                data-market-type="m"
                data-bm-sr="1"
                style={{ textDecoration: "none" }}
              >
                <div id="runner1b3span">
                  <span
                    className="price-odd"
                    id="runner1b3"
                    style={{ fontSize: "1.25rem" }}
                  >
                    {r1b3}
                  </span>
                  <span className="price-amount" id="rate3">
                    {rate3}
                  </span>
                </div>
              </a>

              <a
                onClick={() =>
                  showBetSlip(
                    "b",
                    eventDetails.cat_rnr1,
                    eventDetails.cat_sid1,
                    r1b2
                  )
                }
                className="price-price price-back"
                data-team="New Zealand"
                data-market-type="m"
                data-bm-sr="1"
                style={{ textDecoration: "none" }}
              >
                <div>
                  <span className="price-odd" style={{ fontSize: "1.25rem" }}>
                    {r1b2}
                  </span>
                  <span className="price-amount" id="rate2">
                    {rate2}
                  </span>
                </div>
              </a>

              <a
                onClick={() =>
                  showBetSlip(
                    "b",
                    eventDetails.cat_rnr1,
                    eventDetails.cat_sid1,
                    r1b
                  )
                }
                className="price-price price-back mb-show"
                data-team="New Zealand"
                data-market-type="m"
                data-bm-sr="1"
                style={{
                  backgroundColor: "rgb(141, 210, 240)",
                  textDecoration: "none",
                  fontSize: "1.25rem"
                }}
              >
                {matchOdds && <DisplayOdd odd={r1b} rate={rate1} oddtype="b" />}
              </a>

              <a
                onClick={() =>
                  showBetSlip(
                    "l",
                    eventDetails.cat_rnr1,
                    eventDetails.cat_sid1,
                    r1l
                  )
                }
                className="price-price price-lay-dark ml-4 mb-show"
                data-team="New Zealand"
                data-market-type="m"
                data-bm-sr="1"
                style={{ textDecoration: "none", fontSize: "1.25rem" }}
              >
                {matchOdds && <DisplayOdd odd={r1l} rate={rate4} oddtype="l" />}
              </a>

              <a
                onClick={() =>
                  showBetSlip(
                    "l",
                    eventDetails.cat_rnr1,
                    eventDetails.cat_sid1,
                    r1l2
                  )
                }
                className="price-price price-lay"
                data-team="New Zealand"
                data-market-type="m"
                data-bm-sr="1"
                style={{ textDecoration: "none", fontSize: "1.25rem" }}
              >
                <div id="runner1l2span">
                  <span className="price-odd" style={{ fontSize: "1.25rem" }}>
                    {r1l2}
                  </span>
                  <span className="price-amount" id="rate5">
                    {rate5}
                  </span>
                </div>
              </a>

              <a
                onClick={() =>
                  showBetSlip(
                    "l",
                    eventDetails.cat_rnr1,
                    eventDetails.cat_sid1,
                    r1l3
                  )
                }
                className="price-price price-lay mr-4"
                data-team="New Zealand"
                data-market-type="m"
                data-bm-sr="1"
                style={{ textDecoration: "none", fontSize: "1.25rem" }}
              >
                <div id="runner1l3span">
                  <span className="price-odd" style={{ fontSize: "1.25rem" }}>
                    {r1l3}
                  </span>
                  <span className="price-amount" id="rate6">
                    {rate6}
                  </span>
                </div>
              </a>

              <div
                className="suspended-overlap"
                style={{
                  display:
                    !betAccept ||
                    eventDetails.evt_status === "CLOSED" ||
                    oddStatus !== "OPEN"
                      ? ""
                      : "none"
                }}
              >
                {oddStatus}
              </div>
            </div>
          </div>

          <div
            className="runner-runner"
            style={{
              background:
                eventDetails !== null &&
                eventDetails !== undefined &&
                eventDetails.stat2 === "WINNER"
                  ? "#b7f777"
                  : ""
            }}
          >
            <h3 className="runner-name">
              <div className="runner-info">
                <span className="clippable runner-display-name">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <h4
                            style={{
                              marginBottom: "0px",
                              fontSize: "16px",
                              fontWeight: "600",
                              whiteSpace: "normal"
                            }}
                            className="clippable-spacer"
                          >
                            {eventDetails.cat_rnr2}
                          </h4>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div
                            style={{
                              float: "left",
                              fontSize: "15px",
                              color: rnr2s >= 0 ? "green" : "red"
                            }}
                          >
                            {rnr2s != 0 ? (
                              <span>{formatTruncate(Math.round(rnr2s))}</span>
                            ) : (
                              ""
                            )}
                          </div>
                          <div
                            style={{ marginLeft: "10px", display: "none" }}
                            id="rnr2_bb_m"
                          >
                            &nbsp;&nbsp; <span id="rnr2_m"></span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </div>
            </h3>

            <div className="price-row-box-new">
              <a
                onClick={() =>
                  showBetSlip(
                    "b",
                    eventDetails.cat_rnr2,
                    eventDetails.cat_sid2,
                    r2b3
                  )
                }
                className="price-price price-back"
                data-team="South Africa"
                data-market-type="m"
                data-bm-sr="2"
                style={{ textDecoration: "none" }}
              >
                <div id="runner2b3span">
                  <span className="price-odd" style={{ fontSize: "1.25rem" }}>
                    {r2b3}
                  </span>
                  <span className="price-amount" id="rate9">
                    {rate9}
                  </span>
                </div>
              </a>

              <a
                onClick={() =>
                  showBetSlip(
                    "b",
                    eventDetails.cat_rnr2,
                    eventDetails.cat_sid2,
                    r2b2
                  )
                }
                className="price-price price-back"
                data-team="South Africa"
                data-market-type="m"
                data-bm-sr="2"
                style={{ textDecoration: "none" }}
              >
                <div id="runner2b2span">
                  <span className="price-odd" style={{ fontSize: "1.25rem" }}>
                    {r2b2}
                  </span>
                  <span className="price-amount" id="rate8">
                    {rate8}
                  </span>
                </div>
              </a>

              <a
                onClick={() =>
                  showBetSlip(
                    "b",
                    eventDetails.cat_rnr2,
                    eventDetails.cat_sid2,
                    r2b
                  )
                }
                className="price-price price-back mb-show"
                data-team="South Africa"
                data-market-type="m"
                data-bm-sr="2"
                style={{
                  backgroundColor: "rgb(141, 210, 240)",
                  textDecoration: "none",
                  fontSize: "1.25rem"
                }}
              >
                {matchOdds && <DisplayOdd odd={r2b} rate={rate7} oddtype="b" />}
              </a>

              <a
                onClick={() =>
                  showBetSlip(
                    "l",
                    eventDetails.cat_rnr2,
                    eventDetails.cat_sid2,
                    r2l
                  )
                }
                className="price-price price-lay-dark ml-4 mb-show"
                data-team="South Africa"
                data-market-type="m"
                data-bm-sr="2"
                style={{ textDecoration: "none" }}
              >
                {matchOdds && (
                  <DisplayOdd odd={r2l} rate={rate10} oddtype="l" />
                )}
              </a>

              <a
                onClick={() =>
                  showBetSlip(
                    "l",
                    eventDetails.cat_rnr2,
                    eventDetails.cat_sid2,
                    r2l2
                  )
                }
                className="price-price price-lay"
                data-team="South Africa"
                data-market-type="m"
                data-bm-sr="2"
                style={{ textDecoration: "none" }}
              >
                <div id="runner2l2span">
                  <span className="price-odd" style={{ fontSize: "1.25rem" }}>
                    {r2l2}
                  </span>
                  <span className="price-amount" id="rate11">
                    {rate11}
                  </span>
                </div>
              </a>

              <a
                onClick={() =>
                  showBetSlip(
                    "l",
                    eventDetails.cat_rnr2,
                    eventDetails.cat_sid2,
                    r2l3
                  )
                }
                className="price-price price-lay mr-4"
                data-team="South Africa"
                data-market-type="m"
                data-bm-sr="2"
                style={{ textDecoration: "none" }}
              >
                <div>
                  <span className="price-odd" style={{ fontSize: "1.25rem" }}>
                    {r2l3}
                  </span>
                  <span className="price-amount" id="rate12">
                    {rate12}
                  </span>
                </div>
              </a>

              <div
                className="suspended-overlap"
                style={{
                  display:
                    !betAccept ||
                    eventDetails.evt_status === "CLOSED" ||
                    oddStatus !== "OPEN"
                      ? ""
                      : "none"
                }}
              >
                {oddStatus}
              </div>
            </div>
          </div>

          <div
            className="runner-runner"
            style={{
              display: eventDetails.cat_rnr3 === "NA" ? "none" : "",
              background:
                eventDetails !== null &&
                eventDetails !== undefined &&
                eventDetails.stat3 === "WINNER"
                  ? "#b7f777"
                  : ""
            }}
          >
            <h3 className="runner-name">
              <div className="runner-info">
                <span className="clippable runner-display-name">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <h4
                            style={{
                              marginBottom: "0px",
                              fontSize: "16px",
                              fontWeight: "600",
                              whiteSpace: "normal"
                            }}
                            className="clippable-spacer"
                          >
                            {eventDetails.cat_rnr3}
                          </h4>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div
                            style={{
                              float: "left",
                              fontSize: "15px",
                              color: rnr3s >= 0 ? "green" : "red"
                            }}
                          >
                            {rnr3s != 0 ? (
                              <span>{formatTruncate(Math.round(rnr3s))}</span>
                            ) : (
                              ""
                            )}
                          </div>
                          <div style={{ marginLeft: "10px", display: "none" }}>
                            &nbsp;&nbsp; <span id="rnr2_m"></span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </div>
            </h3>

            <div className="price-row-box-new">
              <a
                onClick={() =>
                  showBetSlip(
                    "b",
                    eventDetails.cat_rnr3,
                    eventDetails.cat_sid3,
                    r3b3
                  )
                }
                className="price-price price-back"
                data-team="South Africa"
                data-market-type="m"
                data-bm-sr="2"
                style={{ textDecoration: "none" }}
              >
                <div id="runner2b3span">
                  <span className="price-odd" id="runner2b3">
                    {r3b3}
                  </span>
                  <span className="price-amount" id="rate9">
                    {rate15}
                  </span>
                </div>
              </a>

              <a
                onClick={() =>
                  showBetSlip(
                    "b",
                    eventDetails.cat_rnr3,
                    eventDetails.cat_sid3,
                    r3b2
                  )
                }
                className="price-price price-back"
                data-team="South Africa"
                data-market-type="m"
                data-bm-sr="2"
                style={{ textDecoration: "none" }}
              >
                <div id="runner2b2span">
                  <span className="price-odd" id="runner2b2">
                    {r3b2}
                  </span>
                  <span className="price-amount" id="rate8">
                    {rate14}
                  </span>
                </div>
              </a>

              <a
                onClick={() =>
                  showBetSlip(
                    "b",
                    eventDetails.cat_rnr3,
                    eventDetails.cat_sid3,
                    r3b
                  )
                }
                className="price-price price-back mb-show"
                data-team="South Africa"
                data-market-type="m"
                data-bm-sr="2"
                style={{
                  backgroundColor: "rgb(141, 210, 240)",
                  textDecoration: "none"
                }}
              >
                {matchOdds && (
                  <DisplayOdd odd={r3b} rate={rate13} oddtype="b" />
                )}
              </a>

              <a
                onClick={() =>
                  showBetSlip(
                    "l",
                    eventDetails.cat_rnr3,
                    eventDetails.cat_sid3,
                    r3l
                  )
                }
                className="price-price price-lay-dark ml-4 mb-show"
                data-team="South Africa"
                data-market-type="m"
                data-bm-sr="2"
                style={{ textDecoration: "none" }}
              >
                {matchOdds && (
                  <DisplayOdd odd={r3l} rate={rate16} oddtype="l" />
                )}
              </a>

              <a
                onClick={() =>
                  showBetSlip(
                    "l",
                    eventDetails.cat_rnr3,
                    eventDetails.cat_sid3,
                    r3l2
                  )
                }
                className="price-price price-lay"
                data-team="South Africa"
                data-market-type="m"
                data-bm-sr="2"
                style={{ textDecoration: "none" }}
              >
                <div id="runner2l2span">
                  <span className="price-odd" id="runner2l2">
                    {r3l2}
                  </span>
                  <span className="price-amount" id="rate11">
                    {rate17}
                  </span>
                </div>
              </a>

              <a
                onClick={() =>
                  showBetSlip(
                    "l",
                    eventDetails.cat_rnr3,
                    eventDetails.cat_sid3,
                    r3l3
                  )
                }
                className="price-price price-lay mr-4"
                data-team="South Africa"
                data-market-type="m"
                data-bm-sr="2"
                style={{ textDecoration: "none" }}
              >
                <div id="runner2l3span">
                  <span className="price-odd" id="runner2l3">
                    {r3l3}
                  </span>
                  <span className="price-amount" id="rate12">
                    {rate18}
                  </span>
                </div>
              </a>

              <div
                className="suspended-overlap"
                style={{
                  display:
                    !betAccept ||
                    eventDetails.evt_status === "CLOSED" ||
                    oddStatus !== "OPEN"
                      ? ""
                      : "none"
                }}
              >
                {oddStatus}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="tb-content"></div>

      <div id="msg_display_div" style={{ display: "none" }}>
        <div
          style={{
            borderTop: "1px solid lightgray",
            margin: "0px 5px",
            borderBottom: "1px solid lightgray",
            padding: "5px"
          }}
        >
          <p
            style={{
              textAlign: "left",
              margin: "0px",
              padding: "0px",
              fontSize: "16px",
              fontWeight: "inherit",
              color: "red"
            }}
          >
            <b id="msg_txt"></b>
          </p>
        </div>
      </div>
    </div>
  );
};
export default MatchOdd;
